import {fromExtent} from "ol/geom/Polygon";
import * as bootstrap from "bootstrap";


export class GdControls {
    constructor(map, bgConfig) {
        this.map = map;

        this.addHomeControl();
        this.addLegendControl();
        this.addInfoControl();
    }

    addLegendControl() {
        let dropdown = $('<div>')
            .addClass('btn-group dropend ol-unselectable ol-control mt-1')
            .append($('<button>')
                .attr('type', 'button')
                .attr('data-bs-toggle', 'dropdown')
                .attr('data-bs-offset', '0,10')
                .attr('aria-expanded', 'false')
                .addClass('btn btn-secondary dropdown-toggle')
                .attr('title', 'Legende anzeigen')
                .html('<i class="fas fa-list-ul fa-xs"></i>')
            )
            .append($('<div class="dropdown-menu">')
                .append($('<table>')
                    .addClass('table table-bordered')
                    .attr('style', 'width:250px')
                    .append($('<tr>')
                        .append($('<td>')
                            .html('<img src="/images/icons/circle_adresse_gefoerdert.svg">')
                        )
                        .append($('<td>')
                            .text('Geförderte Adresse')
                        )
                    )
                    .append($('<tr>')
                        .append($('<td>')
                            .html('<img src="/images/icons/circle_adresse_vortrieb.svg">')
                        )
                        .append($('<td>')
                            .text('Vortriebsadresse')
                        )
                    )
                    .append($('<tr>')
                        .append($('<td>')
                            .html('<img src="/images/icons/circle_adresse_sonstige.svg">')
                        )
                        .append($('<td>')
                            .text('Sonstige')
                        )
                    )
                )
            )
        ;

        $('#gdControls').append(dropdown);
    }

    addHomeControl() {
        let this_ = this;
        let dropdown = $('<div>')
            .addClass('btn-group ol-unselectable ol-control mt-1')
            .append($('<button>')
                .attr('type', 'button')
                .addClass('btn btn-secondary')
                .attr('title', 'Zur Gesamtansicht')
                .html('<i class="fas fa-home fa-xs"></i>')
                .on('click', function () {
                    this_.map.getView().fitInternal(fromExtent([358099,5609367, 375298, 5628262]));
                })
            )
        ;
        $('#gdControls').append(dropdown);
    }

    addInfoControl() {
        let this_ = this;
        let dropdown = $('<div>')
            .addClass('btn-group ol-unselectable ol-control mt-1')
            .append($('<button>')
                .attr('type', 'button')
                .addClass('btn btn-secondary')
                .attr('title', 'Information anzeigen')
                .html('<i class="fas fa-info fa-xs"></i>')
                .on('click', function () {
                    const gdModal = new bootstrap.Modal('#gdModal');
                    gdModal.show();
                })
            )
        ;
        $('#gdControls').append(dropdown);
    }
}